<template>
  <div class="container flex flex-col justify-center items-center p-12 gap-16">
    <div class="flex gap-8 flex-wrap">
      <div class="section p-8 flex flex-col gap-4">
        <h1 class="text-4xl my-4">About Me</h1>
        <p>Welcome to my portfolio! My name is <b>Alexandros Ploumis</b> I am a passionate and experienced Full Stack Web Developer with a robust knowledge of various technologies and platforms. With a focus on delivering high-quality, user-centric web solutions, I specialize in both back-end and front-end development.</p>
        <p>I thrive in a collaborative environment and am always eager to take on new challenges that help me grow both personally and professionally. My goal is to create seamless and engaging web experiences that drive results and exceed client expectations.</p>

      </div>
      <div class="section p-8 flex flex-col gap-4">
        <h1 class="text-4xl my-4">Education</h1>
        <p>I completed my Bachelor's degree in Applied Informatics from the University of Macedonia. During my studies, I gained comprehensive knowledge and practical skills in various areas of informatics, including software development, database management, and information systems.</p>

      </div>
      <div class="section p-8 flex flex-col gap-4">
        <h3 class="text-2xl  my-3">CMS Knowledge</h3>
        <ul class="flex gap-4 mb-4 mobile-column">
          <li class="flex flex-col gap-4">
            <img class="logo" :src="require(`@/assets/icons/wordpress_1.svg`)">
            <div class="li-content">
              <h5 class="text-lg">WordPress</h5>
              <p>Sites, themes, and plugins — built, styled, and bent to the client's will.</p>
            </div>
          </li>
          <li class="flex flex-col gap-4">
            <img class="logo" :src="require(`@/assets/icons/opencart.svg`)">
            <div class="li-content">
              <h5 class="text-lg">OpenCart</h5>
              <p>E-commerce stores built and tuned to actually sell things.</p>
            </div>
          </li>
          <li class="flex flex-col gap-4">
            <img class="logo" :src="require(`@/assets/images/shopranos_1.png`)">
            <div class="li-content">
              <h5 class="text-lg">Shopranos</h5>
              <p>Getting hands-on with SOFTONE's shiny new e-commerce CMS, early-adopter style.</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="section p-8 flex flex-col w-50">
        <h3 class="text-2xl  my-3">Back-End Knowledge</h3>
        <ul class="flex flex-col gap-4 mb-4">
          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/php.svg`)">
            <div class="li-content">
              <h5 class="text-lg">PHP</h5>
              <p>The reliable workhorse behind dynamic, data-driven web apps.</p>
            </div>
          </li>
          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/database.svg`)">
            <div class="li-content">
              <h5 class="text-lg">SQL</h5>
              <p>Designing and tuning databases so your data behaves, even under pressure.</p>
            </div>
          </li>
          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/algorithm.svg`)">
            <div class="li-content">
              <h5 class="text-lg">MVC Architecture</h5>
              <p>Keeping code sane and scalable with the Model-View-Controller pattern.</p>
            </div>
          </li>
          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/api.svg`)">
            <div class="li-content">
              <h5 class="text-lg">RESTful API Development</h5>
              <p>Designing APIs that make client and server play nicely together.</p>
            </div>
          </li>
          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/github.svg`)">
            <div class="li-content">
              <h5 class="text-lg">Version Control</h5>
              <p>Git-fluent, commit-message-caring, merge-conflict-unfazed.</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="section p-8 flex flex-col w-50">
        <h3 class="text-2xl  my-3">Front-End Knowledge</h3>
        <ul class="flex flex-col gap-4 mb-4">
          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/java-script.svg`)">
            <div class="li-content">
              <h5 class="text-lg">JavaScript</h5>
              <p>Bringing interfaces to life with clean, efficient code.</p>
            </div>
          </li>
          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/jquery.svg`)">
            <div class="li-content">
              <h5 class="text-lg">jQuery</h5>
              <p>Still handy for quick, no-nonsense DOM and AJAX work.</p>
            </div>
          </li>
          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/vue.svg`)">
            <div class="li-content">
              <h5 class="text-lg">Vue</h5>
              <p>My framework of choice for building reactive, component-driven apps.</p>
            </div>
          </li>
          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/html-5.svg`)">
            <div class="li-content">
              <h5 class="text-lg">HTML</h5>
              <p>Clean, semantic markup — the foundation everything else stands on.</p>
            </div>
          </li>
          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/css-3.svg`)">
            <div class="li-content">
              <h5 class="text-lg">CSS, Bootstrap, Tailwind</h5>
              <p>Making things responsive and genuinely nice to look at.</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="section p-8 flex flex-col">
        <h1 class="text-4xl my-4">Custom Software Development</h1>
        <p>Beyond the browser, I build custom software tailored to real business needs — solutions that scale, hold up under pressure, and actually make work easier. My focus areas:</p>
        <div class="flex gap-4 mobile-column">
          <div class="flex flex-col w-50 mt-4">
            <img class="logo mt-2" :src="require(`@/assets/images/laravel.png`)">
            <h5 class="text-lg mt-2 mb-1">Laravel Development</h5>
            <ul class="mb-4 ml-2">
              <li><p>Custom web apps built on Laravel, from prototype to production</p></li>
              <li><p>RESTful APIs for third-party integrations</p></li>
              <li><p>Authentication, authorization, and data validation</p></li>
              <li><p>Performance and security via testing and best practices</p></li>
            </ul>
          </div>
          <div class="flex flex-col w-50 mt-4">
            <img class="logo mt-2" :src="require(`@/assets/images/android.png`)">
            <h5 class="text-lg mt-2 mb-1">Android Studio Development</h5>
            <ul class="mb-4 ml-2">
              <li><p>Native Android apps, designed and built from the ground up</p></li>
              <li><p>Intuitive, user-friendly mobile interfaces</p></li>
              <li><p>Third-party API integrations to extend functionality</p></li>
              <li><p>Ongoing maintenance and performance support</p></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="section p-8 flex flex-col">
        <h3 class="text-2xl  my-3">General Knowledge</h3>
        <ul class="flex flex-col gap-4 mb-4">
          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/java.svg`)">
            <div class="li-content">
              <h5 class="text-lg">Java</h5>
              <p>Robust apps across both web and desktop, the old-school reliable way.</p>
            </div>
          </li>

          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/c-sharp.svg`)">
            <div class="li-content">
              <h5 class="text-lg">C#</h5>
              <p>From enterprise software to game logic in Unity.</p>
            </div>
          </li>

          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/node-js.svg`)">
            <div class="li-content">
              <h5 class="text-lg">Node.js</h5>
              <p>Fast, async, API-driven — my go-to for scalable server-side work.</p>
            </div>
          </li>

          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/node-js.svg`)">
            <div class="li-content">
              <h5 class="text-lg">Express</h5>
              <p>Lightweight and flexible — keeps the back-end lean.</p>
            </div>
          </li>

          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/unity.svg`)">
            <div class="li-content">
              <h5 class="text-lg">Unity</h5>
              <p>Building immersive 2D/3D game worlds, scripted in C#.</p>
            </div>
          </li>
          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/icons/github_1.svg`)">
            <div class="li-content">
              <h5 class="text-lg">GitHub</h5>
              <p>Where the code lives, collaborates, and ships via CI.</p>
            </div>
          </li>
          <li class="flex gap-4 items-center">
            <img :src="require(`@/assets/images/go.png`)">
            <div class="li-content">
              <h5 class="text-lg">Go</h5>
              <p>The newest tool in the belt — leaning into concurrency and lean resource use.</p>
            </div>
          </li>

        </ul>
      </div>
    </div>
  </div>
</template>

  <script>
  export default {
    name: 'HomePage'
  };
  </script>

  <style scoped>
  .section {
    transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
    animation: rise 0.6s ease both;
    background-image: linear-gradient(90deg, #64FFDA, #7C5CFF);
    background-repeat: no-repeat;
    background-size: 100% 3px;
    background-position: top;
  }

  .section:hover {
    transform: translateY(-6px);
    border-color: #64FFDA;
    box-shadow: 0 16px 28px -10px rgba(100, 255, 218, 0.25);
  }

  .section:nth-child(1) { animation-delay: 0.05s; }
  .section:nth-child(2) { animation-delay: 0.1s; }
  .section:nth-child(3) { animation-delay: 0.15s; }
  .section:nth-child(4) { animation-delay: 0.2s; }
  .section:nth-child(5) { animation-delay: 0.25s; }
  .section:nth-child(6) { animation-delay: 0.3s; }
  .section:nth-child(7) { animation-delay: 0.35s; }

  @keyframes rise {
    from {
      opacity: 0;
      transform: translateY(16px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  h1, h3 {
    position: relative;
    display: inline-block;
  }

  h1::after, h3::after {
    content: '';
    display: block;
    width: 40px;
    height: 3px;
    margin-top: 6px;
    background: linear-gradient(90deg, #64FFDA, transparent);
    border-radius: 2px;
  }

  li {
    transition: transform 0.2s ease;
  }

  li:hover {
    transform: translateX(4px);
  }

  li:hover h5 {
    color: #64FFDA;
    transition: color 0.2s ease;
  }

  li img {
    transition: transform 0.2s ease;
  }

  li:hover img {
    transform: scale(1.1);
  }

  @media (prefers-reduced-motion: reduce) {
    .section {
      animation: none;
    }
    .section, li, li img {
      transition: none;
    }
  }
  </style>